import { TemplateType } from "@commons-monorepo/index";
import { MainHeaderSideMenuProps } from "./main-header-sidebar-menu.types";
import { MainHeaderSideMenu1, MainHeaderSideMenu2 } from "./skins";

export const MainHeaderSideMenu = (props: MainHeaderSideMenuProps) => {
  return (
    <>
      {props.theme.template.SIDEBAR_MENU ===
        TemplateType.SIDEBAR_MENU_PRINCIPAL_1 && (
        <MainHeaderSideMenu1 {...props} />
      )}
      {props.theme.template.SIDEBAR_MENU ===
        TemplateType.SIDEBAR_MENU_PRINCIPAL_2 && (
        <MainHeaderSideMenu2 {...props} />
      )}
    </>
  );
};
